import {
    BaseLayer,
    MapOptions
} from "esdm-map/dist";
import { BaseLayerType } from "esdm-map/dist/baselayers/BaseLayerType";
import { MapSettings } from "../defs/MapSettings";
import { LhlpBaseLayers } from "../Layers/LhlpBaseLayerFactory";

import { boundingExtent } from 'ol/extent';
import { TenantSettingsBaseLayerResolver } from "../Layers/TenantSettingsBaseLayerResolver";

export class DefaultMapOptions {

    //needed for base layer reprojection
    //static OS_extent = boundingExtent([-841259.18, 6405988.48, 404314.68, 8733289.16]);

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string,
        mapSettings: MapSettings
    ): MapOptions {               

        if (mapSettings != null) {
            let resolver = new TenantSettingsBaseLayerResolver(mapSettings);
            let baseLayers: BaseLayerType[] = resolver.getBaseLayerTypes();

            let opt = new MapOptions();
            opt.baseMaps = baseLayers;
            opt.defaultBaseMap = baseLayers[0];
            opt.enableBoundsTracking = true;
            opt.mapElementId = mapElementId;
            opt.mapStoreKey = mapStoreKey;

            opt.bingApiKey = mapSettings.BingApiKey;
            opt.esdmOsmApiKey = mapSettings.EsdmOsmApiKey;
            opt.mapCentre = mapSettings.GetCentre();
            opt.mapZoom = mapSettings.MapZoom;
            opt.minZoom = mapSettings.MinZoom;
            opt.maxZoom = mapSettings.MaxZoom;
            opt.extent = mapSettings.GetExtents();            

            opt.displayProjection = "EPSG:3857";
            opt.dataProjection = "EPSG:3857";
            opt.dragRotateAndZoom = false;
            opt.maxZoomToBounds = 15;
            opt.zoomToNearestBounds = false;
            return opt;
        }

        return null;        
    }

}